/**
 * Vuex mutations for the "subscribe" module.
 *
 * Synchronous state writers for the following/followers collections. Each
 * mutation operates generically on whichever state key (`following` or
 * `followers`) is named by `params.type` / `collection`, rather than hard
 * -coding a single list. Async work (API calls) lives in operations.js,
 * which commits these mutations with the results.
 */
export default {
  /**
   * Replace `state[params.type]` (e.g. `following`/`followers`) with
   * `data.results`, and — unless `params.only` is set — also update the
   * matching `<type>Count` with `data.count`.
   */
  setGenericCollection(state, { params, data }) {
    if (!state || !params || !state[params.type] || !data) return;

    if (Array.isArray(data.results)) {
      state[params.type] = data.results;

      if(params.only === undefined) {
        state[`${params.type}Count`] = data.count;
      }

    } else {
      console.error("Expected array data for collection:", params.type);
    }
  },


/** Append `data` (one item or an array) to `state[collection]`, skipping items whose `id` is already present. */
addToGenericCollection(state, { collection, data }) {
  if (!state || !collection || !state[collection] || !data) return;

  const itemsToAdd = Array.isArray(data) ? data : [data];

  if (Array.isArray(state[collection])) {
    itemsToAdd.forEach(item => {
      if (!state[collection].some(existingItem => existingItem.id === item.id)) {
        state[collection].push(item);
      }
    });
  } else {
    console.error("Collection is not an array:", collection);
  }
},

/** Upsert `data` (one item or an array) into `state[collection]` by `id`: merge into the existing entry if found, else push it. */
updateInGenericCollection(state, { collection, data }) {
  if (!state || !collection || !state[collection] || !data) return;

  const itemsToUpdate = Array.isArray(data) ? data : [data];

  if (Array.isArray(state[collection])) {
    itemsToUpdate.forEach(item => {
      const index = state[collection].findIndex(existingItem => existingItem.id === item.id);
      if (index !== -1) {
        state[collection].splice(index, 1, { ...state[collection][index], ...item });
      } else {
        state[collection].push(item);
      }
    });
  } else {
    console.error("Collection is not an array:", collection);
  }
},

  /** Remove the item whose `id` matches `data.id` from `state[collection]`. */
  removeFromGenericCollection(state, { collection, data }) {
    if (!state || !collection || !state[collection] || !data) return;
    if (Array.isArray(state[collection])) {
      state[collection] = state[collection].filter((el) => el.id !== data?.id);
    } else {
      console.error("Collection is not an array:", collection);
    }
  },
};
